export default "__VITE_ASSET__DUjhFMDC__"